"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormCheckbox = void 0;
const checkbox_1 = require("../../../components/checkbox/checkbox");
const form_field_1 = require("./form-field");
exports.FormCheckbox = form_field_1.formFieldFactory(checkbox_1.Checkbox);
//# sourceMappingURL=form-checkbox.js.map